var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ 'background-image': `url(${_vm.image})` }),attrs:{"id":"app"}},[_c('nav',[_c('router-link',{staticClass:"m-2",attrs:{"to":"/"}},[_vm._v("Home")]),_c('router-link',{staticClass:"m-2",attrs:{"to":"/recipe/create"}},[_vm._v("Add recipe")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }